import React from 'react';

const WeeklyPlan = () => {
    return (
        <div>
            <h2>Weekly Plan</h2>
            {/* 周计划的具体内容 */}
        </div>
    );
};

export default WeeklyPlan;
